import React from 'react';
import PageTitle from '../../FormElements/PageTitle';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import TextArea from '../../FormElements/TextArea';
import EmailInput from '../../FormElements/EmailInput';
import DropdownList from '../../FormElements/DropdownList';

export default class LicenseSurveyForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			id: null,
			property_id: null,
			has_existing_licenses: '',
			license_description: '',
			has_online_account: '',
			is_willing_to_share_login_details: '',
			online_account_username: '',
			online_account_password: '',
			number_of_bedrooms: '',
			maximum_occupancy: '',
			estimated_annual_gross_revenue: '',
			local_contact_first_name: '',
			local_contact_last_name: '',
			local_contact_address_1: '',
			local_contact_address_2: '',
			local_contact_city: '',
			local_contact_state: '',
			local_contact_postal_code: '',
			local_contact_phone_number: '',
			local_contact_email: '',
			errorsList: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.createBusinessLicenseApplication = this.createBusinessLicenseApplication.bind(
			this
		);
		this.loadData = this.loadData.bind(this);
	}

	componentDidMount() {
		this.loadData();
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	renderHasExistingLicensesQuestionSection() {
		return (
			<div>
				<DropdownList
					label="Do You Have Existing Business Licenses For This Property?"
					displayLabel={true}
					onChange={this.onChange}
					id="has_existing_licenses"
					name="has_existing_licenses"
					value={this.state.has_existing_licenses || ''}
					data={[
						{
							id: 0,
							name: ''
						},
						{
							id: 1,
							name: 'No'
						},
						{
							id: 2,
							name: 'Yes'
						}
					]}
					fieldErrors={this.state.fieldErrors}
				/>
			</div>
		);
	}

	renderExistingLicensesSection() {
		return (
			<div>
				<div className="mb-8">
					<p className="font-light italic">
						Please provide your existing business licenses and online account
						login information. We will use this information so that we don't
						apply for a duplicate license and to make sure your tax licenses are
						setup correctly.
					</p>
				</div>
				<Label htmlFor="license_description">
					Existing Business Licenses & Tax IDs
				</Label>
				<TextArea
					id="license_description"
					name="license_description"
					value={this.state.license_description}
					onChange={this.onChange}
					placeholder="GE - 987654321-01, TA - 123456789-01"
				/>
				<DropdownList
					label="Do You Have An Online Account?"
					displayLabel={true}
					onChange={this.onChange}
					id="has_online_account"
					name="has_online_account"
					value={this.state.has_online_account}
					data={[
						{
							id: 0,
							name: ''
						},
						{
							id: 1,
							name: 'No'
						},
						{
							id: 2,
							name: 'Yes'
						}
					]}
				/>
				{this.state.has_online_account === 'Yes' ? (
					<div>
						<DropdownList
							label="Are You Willing To Share Your Login Details?"
							displayLabel={true}
							onChange={this.onChange}
							id="is_willing_to_share_login_details"
							name="is_willing_to_share_login_details"
							value={this.state.is_willing_to_share_login_details}
							data={[
								{
									id: 0,
									name: ''
								},
								{
									id: 1,
									name: 'No'
								},
								{
									id: 2,
									name: 'Yes'
								}
							]}
						/>
						{this.state.is_willing_to_share_login_details === 'Yes' ? (
							<div>
								<Label htmlFor="online_account_username">
									Account Username
								</Label>
								<TextInput
									id="online_account_username"
									name="online_account_username"
									value={this.state.online_account_username}
									onChange={this.onChange}
								/>
								<Label htmlFor="online_account_password">
									Account Password
								</Label>
								<TextInput
									id="online_account_password"
									name="online_account_password"
									value={this.state.online_account_password}
									onChange={this.onChange}
								/>
							</div>
						) : this.state.is_willing_to_share_login_details === 'No' ? (
							<div className="mb-8">
								<p className="font-light italic">
									Ok, we understand your concern. We will be contacting you to
									discuss next steps. Also, we want to assure you that this is
									part of the onboarding process and your data is safe with us.
								</p>
							</div>
						) : (
							''
						)}
					</div>
				) : this.state.has_online_account === 'No' ? (
					<div />
				) : (
					''
				)}
			</div>
		);
	}

	renderLicenseSurveySection() {
		return (
			<div>
				<div className="mb-8">
					<p className="font-light italic">
						Please answer the following questions so that we can get started on
						your business license application.
					</p>
				</div>
				<Label htmlFor="number_of_bedrooms">Number of Bedrooms</Label>
				<TextInput
					id="number_of_bedrooms"
					name="number_of_bedrooms"
					value={this.state.number_of_bedrooms}
					onChange={this.onChange}
				/>
				<Label htmlFor="maximum_occupancy">Maximum Occupancy</Label>
				<TextInput
					id="maximum_occupancy"
					name="maximum_occupancy"
					value={this.state.maximum_occupancy}
					onChange={this.onChange}
				/>
				<Label htmlFor="estimated_annual_gross_revenue">
					Estimated Annual Gross Rental Revenue
				</Label>
				<TextInput
					id="estimated_annual_gross_revenue"
					name="estimated_annual_gross_revenue"
					value={this.state.estimated_annual_gross_revenue}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_first_name">
					Local Contact First Name
				</Label>
				<TextInput
					id="local_contact_first_name"
					name="local_contact_first_name"
					value={this.state.local_contact_first_name}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_last_name">Local Contact Last Name</Label>
				<TextInput
					id="local_contact_last_name"
					name="local_contact_last_name"
					value={this.state.local_contact_last_name}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_address_1">
					Local Contact Address Line 1
				</Label>
				<TextInput
					id="local_contact_address_1"
					name="local_contact_address_1"
					value={this.state.local_contact_address_1}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_address_2">
					Local Contact Address Line 2
				</Label>
				<TextInput
					id="local_contact_address_2"
					name="local_contact_address_2"
					value={this.state.local_contact_address_2}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_city" Local Contact>
					Local Contact City
				</Label>
				<TextInput
					id="local_contact_city"
					name="local_contact_city"
					value={this.state.local_contact_city}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_state">Local Contact State</Label>
				<TextInput
					id="local_contact_state"
					name="local_contact_state"
					value={this.state.local_contact_state}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_postal_code">
					Local Contact Zip Code
				</Label>
				<TextInput
					id="local_contact_postal_code"
					name="local_contact_postal_code"
					value={this.state.local_contact_postal_code}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_phone_number">Phone Number</Label>
				<TextInput
					id="local_contact_phone_number"
					name="local_contact_phone_number"
					value={this.state.local_contact_phone_number}
					onChange={this.onChange}
				/>
				<Label htmlFor="local_contact_email">Email</Label>
				<EmailInput
					id="local_contact_email"
					name="local_contact_email"
					value={this.state.local_contact_email}
					onChange={this.onChange}
				/>
			</div>
		);
	}

	renderButtonsSection() {
		return (
			<div className="grid">
				<div className="lg:justify-self-end">
					<FormSubmit
						onSubmit={this.onSubmit}
						label={
							this.props.isEditing ? (
								'Save changes'
							) : (
								'Submit license survey'
							)
						}
					/>
				</div>
			</div>
		);
	}

	render() {
		// console.log('LicenseSurveyForm', this.props, this.state);
		return (
			<div className="LicenseSurveyForm w-full py-4">
				<PageTitle
					title={
						this.props.isEditing ? (
							'Update your license survey'
						) : (
							'Complete your license survey'
						)
					}
				/>
				<GlobalErrorsBox globalErrors={this.state.errors} />
				<FormSection>
					{this.renderHasExistingLicensesQuestionSection()}
					{this.state.has_existing_licenses === 'Yes' ? (
						this.renderExistingLicensesSection()
					) : this.state.has_existing_licenses === 'No' ? (
						this.renderLicenseSurveySection()
					) : (
						''
					)}
				</FormSection>
				{this.state.has_existing_licenses !== '' ? (
					this.renderButtonsSection()
				) : (
					''
				)}
			</div>
		);
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		// console.log('Create license survey call stated...');
		e.preventDefault();
		e.stopPropagation();

		$.ajax({
			type: 'POST',
			url: this.props.update_business_license_survey_endpoint.replace(
				'id',
				this.state.id
			),
			dataType: 'json',
			data: {
				business_license_survey: {
					property_id: this.state.property_id,
					has_existing_licenses:
						this.state.has_existing_licenses === 'Yes'
							? true
							: this.state.has_existing_licenses === 'No' ? false : '',
					license_description: this.state.license_description,
					has_online_account:
						this.state.has_online_account === 'Yes'
							? true
							: this.state.has_online_account === 'No' ? false : '',
					is_willing_to_share_login_details:
						this.state.is_willing_to_share_login_details === 'Yes'
							? true
							: this.state.is_willing_to_share_login_details === 'No'
								? false
								: '',
					online_account_username: this.state.online_account_username,
					online_account_password: this.state.online_account_password,
					number_of_bedrooms: this.state.number_of_bedrooms,
					maximum_occupancy: this.state.maximum_occupancy,
					estimated_annual_gross_revenue: this.state
						.estimated_annual_gross_revenue,
					local_contact_first_name: this.state.local_contact_first_name,
					local_contact_last_name: this.state.local_contact_last_name,
					local_contact_address_1: this.state.local_contact_address_1,
					local_contact_address_2: this.state.local_contact_address_2,
					local_contact_city: this.state.local_contact_city,
					local_contact_state: this.state.local_contact_state,
					local_contact_postal_code: this.state.local_contact_postal_code,
					local_contact_phone_number: this.state.local_contact_phone_number,
					local_contact_email: this.state.local_contact_email
				}
			},
			error: (response) => {
				// console.log('Create/update ownership call failed.', response.responseJSON);
				this.setState({
					// errorsList: response.responseJSON.errors, // Enable for errors list
					fieldErrors: response.responseJSON.field_errors // Enable for field errors
				});
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}).done((response, status) => {
			// console.log('Create license survey call successful.', response, status);
			// We need create a business license application if one does not exist but only one time
			if (false) {
				this.createBusinessLicenseApplication();
			}
			window.location.href = `/properties/${this.props.propertyId}`;
		});
	}

	createBusinessLicenseApplication() {
		// console.log('Create business license application call stated...');
		$.ajax({
			type: 'POST',
			url: this.props.create_business_license_application_endpoint,
			dataType: 'json',
			data: {
				property_id: 1
			},
			error: (response) => {
				// console.log(
				// 	'Create business license call failed.',
				// 	response,
				// 	response.responseJSON.errors
				// );
			}
		}).done((response, status) => {
			// console.log('Create business license call successful.', response, status);
		});
	}

	loadData() {
		// console.log('props', this.props);
		$.ajax({
			type: 'GET',
			url: this.props.get_business_license_survey_by_property_endpoint.replace(
				'property_id',
				this.props.propertyId
			)
		}).done((payload) => {
			const result = payload;
			// console.log('License Survey loadData done', result);
			this.setState({
				id: result.data[0].id,
				property_id: result.data[0].property_id,
				has_existing_licenses: result.data[0].has_existing_licenses
					? 'Yes'
					: !result.data[0].has_existing_licenses ? 'No' : '',
				license_description: result.data[0].license_description,
				has_online_account: result.data[0].has_online_account
					? 'Yes'
					: !result.data[0].has_online_account ? 'No' : '',
				is_willing_to_share_login_details: result.data[0]
					.is_willing_to_share_login_details
					? 'Yes'
					: !result.data[0].is_willing_to_share_login_details ? 'No' : '',
				online_account_username: result.data[0].online_account_username,
				online_account_password: result.data[0].online_account_password,
				number_of_bedrooms: result.data[0].number_of_bedrooms,
				maximum_occupancy: result.data[0].maximum_occupancy,
				estimated_annual_gross_revenue:
					result.data[0].estimated_annual_gross_revenue,
				local_contact_first_name: result.data[0].local_contact_first_name,
				local_contact_last_name: result.data[0].local_contact_last_name,
				local_contact_address_1: result.data[0].local_contact_address_1,
				local_contact_address_2: result.data[0].local_contact_address_2,
				local_contact_city: result.data[0].local_contact_city,
				local_contact_state: result.data[0].local_contact_state,
				local_contact_postal_code: result.data[0].local_contact_postal_code,
				local_contact_phone_number: result.data[0].local_contact_phone_number,
				local_contact_email: result.data[0].local_contact_email
			});
		});
	}
}
